import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/catch';
import { FeedbackModel } from '../../../api/feedback/feed';
import { ApplicationService } from '../../../api/application/application.service';
import { ComboApplication } from '../../../api/application/comboapplication';
import { FeedbackService } from 'api/feedback/feedback.service';
declare var $: any;
declare var jQuery: any;
@Component({
    selector: 'feedback-page',
    templateUrl: './feedback.html'
})
export class FeedbackComponent implements OnInit {
    feedbackList: FeedbackModel[];
    feedback: FeedbackModel;
    applicationList: ComboApplication[];
    selectApplication: string;
    selectdevicetype: string;
    msg = "";
    isPush: boolean;
    message: string;
    id: string;
    i: number;
    constructor(private FeedbackService: FeedbackService, private applicationService: ApplicationService,
        private router: Router) {
    }
    ngOnInit() {
        if (localStorage.getItem('id_token') && (localStorage.getItem('type') == 'SUPERADMIN' || localStorage.getItem('type') == 'ADMIN')) {
            this.initNotificationList();
        } else {
            this.router.navigate(['/']);
        }
    }
    initNotificationList() {
        this.applicationService
            .ComboApplication()
            .then(data => {
                this.applicationList = data;
                this.selectApplication = this.applicationList[0].sku;
                this.selectdevicetype = "Android";
            }).then(dttt => {
                this.getNotification();
            })
    }
    getNotification() {
        var jData = {
            applicationId: this.selectApplication
        }
        this.FeedbackService
            .allFeedback(jData)
            .then(
                data => {
                    this.feedbackList = data
                }
            );
    }
    cancelAction() {
        this.msg = "";
        this.isPush = false;
    }
    onChange(countryGroupValue) {
        this.selectApplication = countryGroupValue;
        this.getNotification();
    }
    deleteFeedback(i, notifi) {
        this.i = i;
        this.feedback = notifi;
        $(function () {
            $('#deleteSureModal').modal('toggle');
        });
    }
    deleteSureFeedback() {
        this.FeedbackService
            .deleteFeedback(this.feedback.id)
            .then(data => {
                if (data.status == true) {
                    this.feedbackList.splice(this.i, 1)
                    $.notify({
                        message: data.message
                    }, {
                        type: 'success',
                        placement: {
                            from: 'bottom',
                            align: 'left'
                        },
                        delay: 100,
                        timer: 100
                    });
                } else {
                    $.notify({
                        message: data.message
                    }, {
                        type: 'danger',
                        placement: {
                            from: 'bottom',
                            align: 'left'
                        },
                        delay: 100,
                        timer: 100
                    });
                }
            });
        $(function () {
            $('#deleteSureModal').modal('toggle');
        });
        this.cancelAction();
    }
}



// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/app/structure/feedback/feedback.page.ts